<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 100 100" class="fill-current">
        <g id="SVGRepo_iconCarrier">
            <title>Shipping Icon</title>
            <circle cx="42" cy="31" r="13" fill="#f3bc74"></circle>
            <path d="M98,65V81H89a6,6,0,0,0-12,0H70V48H87Zm-7,0L85,55H77V65H91Z" fill="#f1b15a"></path>
            <path d="M23.75,82H14a1,1,0,0,1-1-1V31a1,1,0,0,1,1-1H24v2H15V80h8.75v2Z" fill="#965706"></path>
            <path d="M30,88a7,7,0,1,1,7-7A7,7,0,0,1,30,88Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,30,76Z" fill="#965706"></path>
            <path d="M42,50A19,19,0,1,1,61,31,19,19,0,0,1,42,50Zm0-36A17,17,0,1,0,59,31,17,17,0,0,0,42,14Z" fill="#965706"></path>
            <path d="M98,82H89V80h8V65.29L86.46,49H70V47H87a1,1,0,0,1,.84.46l11,17A1,1,0,0,1,99,65V81A1,1,0,0,1,98,82Z" fill="#965706"></path>
            <path d="M70,82H36.25V80H69V32H60V30H70a1,1,0,0,1,1,1V81A1,1,0,0,1,70,82Z" fill="#965706"></path>
            <path d="M83,88a7,7,0,1,1,7-7A7,7,0,0,1,83,88Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,83,76Z" fill="#965706"></path>
            <rect x="5" y="57" width="16" height="2" fill="#965706"></rect>
            <rect x="70" y="80" width="7" height="2" fill="#965706"></rect>
            <rect x="1" y="47" width="20" height="2" fill="#965706"></rect>
            <rect x="5" y="37" width="16" height="2" fill="#965706"></rect>
        </g>
    </svg>
</template>